export default function PostMedia({ src, className = "", testid }) {
  if (!src) return null;
  const isVideo = /\.(mp4|webm|mov|quicktime)(\?|$)/i.test(src);
  if (isVideo) {
    return <video src={src} className={className} muted loop playsInline controls preload="metadata" data-testid={testid} />;
  }
  return <img src={src} alt="" loading="lazy" className={className} data-testid={testid} />;
}
